import van from "vanjs-core"
import { showVideoPopup } from './popup'
//import "bootstrap-icons/font/bootstrap-icons.css";
//import "play-circle.svg" from "bootstrap-icons/icons/play-circle.svg"
const { div, h5, h6, img, small, span } = van.tags

const playIcon = () => {
    const { circle, path, svg } = van.tagsNS("http://www.w3.org/2000/svg")
    return svg({ width: "16", height: "16", fill: "currentColor", class: "bi bi-play-circle rl-video-play ", viewBox: "0 0 16 16" },
        path({ "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }),
        path({ "d": "M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445" }),
    )

}


export function crashCourse() {

    const container = document.getElementById('rl_crash_course_videos');
    if (!container) {
        return;
    }

    const videos = [
        ['rJdgdkiADB4', 'Verification'],
        ['QGAuLgOjCu0', 'Purging Cache'],
        ['ol4nuYuYTeM', 'Me Mode'],
        ['lC0vWlugHJ4', 'Image Settings'],
        ['z6fuEHr6lYs', 'CSS Settings'],
        ['QxwaDxtRw-I', 'Delegate Access'],
        ['uBPMn2mvnrs', 'Linking Cloudflare'],
    ];
    const row = div({ class: "row" }, h5({ class: "mb-3" }, 'Crash Courses'))

    videos.forEach(v => {
        van.add(row, getVideoBox(v[1], v[0]))
    })

    van.add(container, div(
        { class: "row mb-4" },
        div({ class: "col" },
            div({ class: "bg-white rounded p-4" }, row)
        )))
}

function getVideoBox(title, videoID) {
    const imgSrc = `https://img.youtube.com/vi/${videoID}/mqdefault.jpg`;
    return div(
        {
            class: "col-sm-12 col-md-6 col-lg-4 mb-4 text-secondary text-center rl-div-video rl-cp",
            onclick: () => showVideoPopup(videoID)
        },
        h6({ class: "mb-3" }, title),
        img({ loading: 'lazy', src: imgSrc, alt: "-" }),
        playIcon()
    )
}

export function primerVideos() {
    const doms = document.querySelectorAll('primer');
    if (!doms) {
        return;
    }
    doms.forEach(d => {
        const videoID = d.dataset.videoId
        const align = d.dataset.align;
        const duration = d.dataset.duration;
        const durText = duration <= 100 ? " " + duration + " seconds primer" : " " + Math.round(duration / 60) + " min primer"

        const node = div(
            { class: "col-12 mt-2 " + (align == "center" ? "text-center" : ""), onclick: () => showVideoPopup(videoID) },
            small({ class: "text-secondary rl-cp " },
                span({ class: "dashicons dashicons-video-alt3 mt-1" }), durText)
        )
        van.add(d, node)
    })
}